export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/pk.950a123d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};